import { httpRequest } from '@/utils/axios';

export type CustomerMeasurementSize = 'narrow' | 'medium' | 'wide' | 'extra_wide';
export type CustomerMeasurementFeedback = 'positive' | 'negative';

export interface CustomerMeasurementData {
  pd: number | null;
  pd_measured_at: number | null;
  face_width: number | null;
  face_width_measured_at: number | null;
  recommended_sizes: CustomerMeasurementSize[];
  feedback_submitted: boolean;
}

export interface CustomerMeasurementResponse<T> {
  code: number;
  msg: string;
  data: T;
}

export type SaveCustomerMeasurementPayload =
  | {
      save_mode: 'direct' | 'guest_merge';
      measurement_type: 'pd';
      pd: number;
      measured_at: number;
    }
  | {
      save_mode: 'direct' | 'guest_merge';
      measurement_type: 'face_width';
      face_width: number;
      recommended_sizes: CustomerMeasurementSize[];
      measured_at: number;
    };

export interface SaveCustomerMeasurementData {
  measurement: CustomerMeasurementData;
  accepted_fields: Array<'pd' | 'face_width'>;
  discarded_fields: Array<'pd' | 'face_width'>;
}

export interface SaveCustomerMeasurementFeedbackData {
  accepted: boolean;
  feedback_submitted: boolean;
}

interface CustomerMeasurementRequest {
  (
    url: 'GET:/api/customer/measurement',
    params: undefined,
    toastConfig: { success: boolean; fail: boolean },
  ): Promise<CustomerMeasurementResponse<CustomerMeasurementData>>;
  (
    url: 'POST:/api/customer/measurement',
    params: { data: SaveCustomerMeasurementPayload },
    toastConfig: { success: boolean; fail: boolean },
  ): Promise<CustomerMeasurementResponse<SaveCustomerMeasurementData>>;
  (
    url: 'POST:/api/customer/measurement/feedback',
    params: { data: { feedback: CustomerMeasurementFeedback } },
    toastConfig: { success: boolean; fail: boolean },
  ): Promise<CustomerMeasurementResponse<SaveCustomerMeasurementFeedbackData>>;
}

// OpenAPI 生成文件尚未包含新接口，先在 wrapper 内按后端联调文档收窄契约。
const requestCustomerMeasurement = httpRequest as unknown as CustomerMeasurementRequest;
const SILENT_TOAST_OPTIONS = { success: false, fail: false };

export const fetchCustomerMeasurement = () =>
  requestCustomerMeasurement('GET:/api/customer/measurement', undefined, SILENT_TOAST_OPTIONS);

export const saveCustomerMeasurement = (data: SaveCustomerMeasurementPayload) =>
  requestCustomerMeasurement('POST:/api/customer/measurement', { data }, SILENT_TOAST_OPTIONS);

export const saveCustomerMeasurementFeedback = (feedback: CustomerMeasurementFeedback) =>
  requestCustomerMeasurement(
    'POST:/api/customer/measurement/feedback',
    { data: { feedback } },
    SILENT_TOAST_OPTIONS,
  );
